import { Authorization, serviceCall } from "@serenity-is/corelib";
import { ScriptUserDefinition } from "../../ServerTypes/ScriptUserDefinition";
import { TenantRow } from "../../ServerTypes/App";

export function initTenantSelection() {

    const menu = document.querySelector(".s-tenant-selection-menu");

    if (!menu)
        return;

    const user = Authorization.userDefinition as ScriptUserDefinition;

    if (!user?.Tenants)
        return;

    user.Tenants.forEach((t: TenantRow) => {

        const li = document.createElement("li");

        const a = document.createElement("a");
        a.className = "dropdown-item";
        a.href = "javascript:;";
        a.textContent = t.Name;
        if (t.Id === user.TenantId)
            a.classList.add("active");
        a.onclick = async () => {
            await serviceCall({
                url: "~/Account/ChangeTenant",
                request: {
                    TenantId: t.Id,
                    TenantName: t.Name
                }
            });

            window.location.reload();
        };

        li.appendChild(a);
        menu.appendChild(li);
    });
}